import React, { useState, useLayoutEffect } from "react";
import Home from "./Home";
import MobileHome from "./MobileHome";
const HomeContainer =({page}) =>{

    const [screenType, setScreenType] = useState(0);

    useLayoutEffect(() => {
        const handleResize = () => {
            var height = window.innerHeight;
            var width = window.innerWidth;
            var ratio = height / width;
            if(ratio >= 1.556){ 
                setScreenType(0)    //phone
            }else if(ratio >= 0.949){
                setScreenType(1)    //tablet
            }else{
                setScreenType(2)    //laptop
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            if(window != null){
                window.removeEventListener("resize", handleResize)
            }
        };
    }, []);
    return(
        <div>
        {screenType === 2 && <Home page={page ? page : 'home'}/>}
        {screenType === 1 && <MobileHome page={page}/>}
        {screenType === 0 && <MobileHome page={page}/>}
       </div>
    )
}

export default HomeContainer;